import React, { Component } from 'react';

import Header from './components/header/header';

import Main from './main';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';



class App extends Component {
  render() {
    return (
      <div>

          <Header/>
          <div className={"title"}>
          <h4>AQUASAFE</h4>
              <h5><FormattedMessage id={"subtitle"} defaultMessage={"Plataforma de atenção à saúde do trabalhador na aquicultura"}/></h5></div>
              <Main />
        </div>
    );
  }
}

export default App;
